<template>
  <div class="mit-volume-unit">
      <v-select outlined dense return-object
        :items="units"
        v-model="selectedUnit"
        item-text="display"
        item-value="unit"
        label="Units"
        @change="changedUnits"
        style="width:175px;"></v-select>
  </div>
</template>

<script>
import MitUnitsService from '../services/MitUnitsService.js';

export default {
  name: 'MitVolumeUnit',
  components: {
  },
  data: function() {
    return {
      units:[],
      selectedUnit:null
    }
  },
  created(){
      this.units = MitUnitsService.getVolumeUnitsList();
  },
  mounted() {
    this.selectedUnit = MitUnitsService.getUserVolumeUnit();
  },
  methods : {
    changedUnits(){
      MitUnitsService.setUserVolumeUnit(this.selectedUnit);
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
